import async from 'async';
import _ from 'lodash';
import momentDurationFormatSetup from 'moment-duration-format';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

//- Material UI / Style
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Snackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import DriverReportContainer from '../../containers/Driver/DriverReport';
import ResourceContainer from '../../containers/Resource';
import TicketContainer from '../../containers/Ticket/Ticket';

//- UI / Form
import Grid from '@material-ui/core/Grid';
import SavingDialog from '../../components/dialogs/SavingDailog';
import FormDatePicker from '../../components/form/FormDatePicker';
import FormSelect from '../../components/form/FormSelect';
import FormSubmitButton from '../../components/form/FormSubmitButton';
import FormSwitch from '../../components/form/FormSwitch';
import FormText from '../../components/form/FormText';
import FormTextArea from '../../components/form/FormTextArea';
import FormTimePicker from '../../components/form/FormTimePicker';
import Note from '../../components/Note';
import SectionHeader from '../../components/SectionHeader';
//import {gridMargin} from "../../components/form/general";

import { infoByReportType } from '../../libs/reportInfo';

import AccidentDrawing from '../../components/AccidentDrawing';
import requireClockIn from '../../components/timeClock/requireClockIn';

momentDurationFormatSetup(moment);

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		driverLabel: {
			fontSize: 12,
			color: '#999',
		},
		driverName: {
			fontSize: 24,
			borderBottom: '1px solid #ccc',
		},
	};
};

class SaveReport extends Component {
	constructor(props) {
		super(props);

		const action = _.get(this.props, 'match.params.action');
		const reportType = _.get(this.props, 'match.params.reportType');
		const driverReportId =
			parseInt(_.get(this.props, 'match.params.driverReportId'), 10) || undefined;
		const ticketId = parseInt(_.get(this.props, 'match.params.ticketId'), 10) || undefined;

		const isUpdate = action === 'update';

		this.state = {
			color: 'green',
			isUpdate,
			reportType,
			driverReportId,
			ticketId,

			formHasBeenFilled: false,

			formFieldError: {},
			isSavingOpen: false,
			savingStatus: undefined,
			reportOpenedMoment: moment(),
			elapsed: 0,
		};
	}

	componentDidMount() {
		const { ticket, getTicket } = this.props;
		const { ticketId, isUpdate } = this.state;
		this.timer = setInterval(this.tick, 1000);

		if (ticketId && !isUpdate) {
			if (!ticket) {
				getTicket({ params: { ticketIds: [ticketId] } });
			} else {
				this.fillFormFromTicket();
			}
		}
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
		const { ticket } = this.props;
		const { ticketId, isUpdate, formHasBeenFilled } = this.state;

		if (!isUpdate && ticketId && ticket && !formHasBeenFilled && !prevState.formHasBeenFilled) {
			this.fillFormFromTicket();
		}
	}

	fillFormFromTicket = () => {
		const { ticket } = this.props;

		const { schemaValues } = ticket;

		const newState = { formHasBeenFilled: true };
		_.keys(schemaValues).forEach((key) => {
			newState[key] = schemaValues[key];
		});
		this.setState(newState);
	};

	componentWillUnmount() {
		clearInterval(this.timer);
	}

	tick = () => {
		this.setState({
			elapsed: moment().diff(this.state.reportOpenedMoment, 'seconds'),
		});
	};

	//- Path is always a string
	//- value is never an event (value.target)
	onChange = (value, path) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			base = _.cloneDeep(base);
			_.set(base, arrayPath.slice(1), value);
			newState[basePath] = base;
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);
		delete formFieldError[path];
		newState.formFieldError = formFieldError;

		this.setState(newState);
	};

	autoFill = () => {
		const { reportType } = this.state;
		const formFields = infoByReportType[reportType].formFields;

		function shuffle(string) {
			const arr = string.split('');
			const char = ' ';
			let n = 30;

			while (n--) {
				arr.splice(Math.floor(Math.random() * (arr.length + 1)), 0, char);
			}

			return arr.join('');
		}

		const newState = {};
		formFields.forEach((formField) => {
			const fields = _.isArray(formField) ? formField : [formField];

			fields.forEach((field) => {
				const { path, type, section, note } = field;
				if (section || note) {
					return;
				}

				if (type === 'boolean') {
					newState[path] = true;
				} else if (type === 'date' || type === 'dateYearPicker') {
					newState[path] = moment().format('YYYY-MM-DD');
				} else if (type === 'time') {
					newState[path] = moment().format('YYYY-MM-DDTHH:mm:ss[Z]');
				} else if (type === 'enum') {
					newState[path] = field.options[_.random(0, field.options.length - 1)].value;
				} else if (type === 'multilineString') {
					newState[path] = _.times(_.random(120, 240), () => _.random(35).toString(36)).join('');
					newState[path] = shuffle(newState[path]);
				} else {
					newState[path] = _.times(_.random(5, 20), () => _.random(35).toString(36)).join('');
				}
			});
		});
		this.setState(newState);
	};

	closeSavingDialog = () => {
		this.setState({ onContinue: false });
	};

	continueSavingDialog = () => {
		this.props.history.push(`/driver/pickReport`);
	};

	//getBase64String
	handleSave = () => {
		const { addDriverReport, updateDriverReport, authUser, showErrors } = this.props;

		const { reportType, isUpdate, driverReportId, reportOpenedMoment, ticketId } = this.state;

		const formFields = infoByReportType[reportType].formFields;

		const fieldsToCollect = [];
		formFields.forEach((formField) => {
			const fields = _.isArray(formField) ? formField : [formField];

			fields.forEach((field) => {
				if (field.section) {
					return;
				}
				if (field.note) {
					return;
				}
				if (field.type === 'accidentDrawing') {
					return;
				}
				fieldsToCollect.push(field);
			});
		});

		//- Required fields
		const formFieldError = {};
		const params = {
			driverUserId: authUser.userId,
			reportType,
			reportFields: [],
			reportOpenedDateTime: reportOpenedMoment.format('YYYY-MM-DD HH:mm:ss'),
			reportSubmittedDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
		};

		if (ticketId) {
			params.forTicketId = ticketId;
		}

		fieldsToCollect.forEach(({ path, type, label, isRequired }) => {
			params.reportFields.push({
				fieldName: path,
				fieldValue: this.state[path],
				fieldType: type,
			});

			//if (type === 'boolean') { return; }
			if (isRequired && !this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({
			isSavingOpen: true,
			savingStatus: 'saving',
		});

		if (!isUpdate) {
			async.waterfall(
				[
					(callback) => {
						this.saveDrawing({ callback });
					},
					(resourceId, callback) => {
						if (resourceId) {
							params.reportFields.push({
								fieldName: 'accidentDrawingResourceId',
								fieldValue: resourceId,
								fieldType: 'resourceId',
							});
						}

						addDriverReport({
							authUser,
							params,
							callback,
						});
					},
				],
				this.postSave
			);
		} else {
			params.driverReportId = driverReportId;
			updateDriverReport({
				authUser,
				params,
				callback: this.postSave,
			});
		}
	};

	saveDrawing = ({ callback }) => {
		const { reportType } = this.state;

		if (reportType !== 'accident') {
			return callback(null, null);
		}

		//- Save teh resource
		const { addResource } = this.props;

		async.waterfall(
			[
				(callback) => {
					const getBase64String = this.getBase64StringFromAccidentDrawing;
					if (!getBase64String) {
						return callback(`Error can't find getBase64String function`);
					}
					getBase64String({ callback });
				},
				(base64String, callback) => {
					addResource({
						params: {
							base64String,
						},
						callback,
					});
				},
			],
			(err, r) => {
				if (err) {
					return callback(err);
				}
				const resourceId = _.get(r, 'resourceIds.0');

				if (!resourceId) {
					console.error('Missing resource', r);
					return callback('Could not get resourceId back from server');
				}
				return callback(null, resourceId);
			}
		);
	};

	postSave = (err) => {
		const { showErrors, searchMyTickets, authUser } = this.props;

		//- Refresh my ticket list
		searchMyTickets({
			assignedToUserId: authUser.userId,
		});

		if (err) {
			this.setState({ isSavingOpen: false });
			return showErrors(_.isArray(err) ? err : [err]);
		}

		this.setState({
			savingStatus: 'done',
		});

		/*
		setTimeout(() => {
			this.setState({
				isSavingOpen : false,
			});
		}, 500);
		*/
	};

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const { classes, isAdmin, authUser = {}, ticket } = this.props;

		const { isSavingOpen, savingStatus, elapsed, ticketId } = this.state;

		const { reportType } = this.state;
		const { title, doNotShowTicketDetails } = infoByReportType[reportType];
		const durationFormatted = moment.duration(elapsed, 'seconds').format('mm:ss', { trim: false });

		if (ticketId && !ticket) {
			return <div className={classes.globalFetching}>Fetching ticket info...</div>;
		}

		return (
			<Paper className={classes.globalMainPaper}>
				<div className={classes.globalMainHeadline}>{title}</div>

				<Grid spacing={2} container>
					<Grid item xs={12} sm={10} md={10} lg={8}>
						<Grid spacing={2} container>
							<Grid item xs={12}>
								<div className={classes.driverLabel}>Driver</div>
								<div className={classes.driverName}>
									{authUser.firstName} {authUser.lastName}
								</div>
							</Grid>
						</Grid>

						<Grid spacing={2} container>
							<Grid item xs={12}>
								<Note
									label={
										'If this is not your name' +
										' please log out and log back in under your account'
									}
								/>
							</Grid>
						</Grid>

						{!doNotShowTicketDetails && (
							<Grid spacing={2} container style={{ paddingTop: 10 }}>
								<Grid item xs={12}>
									<SectionHeader label="Ticket Details" isTop={true} />
									<div style={{ border: '1px solid #ddd', padding: 12 }}>{this.state.details}</div>
								</Grid>
							</Grid>
						)}
					</Grid>
				</Grid>

				{this.renderReportFields()}

				<FormSubmitButton onClick={this.handleSave} buttonText={`Submit Report`} />

				{isAdmin && (
					<Button variant="outlined" onClick={this.autoFill}>
						TEST : AutoFill
					</Button>
				)}

				<SavingDialog
					open={isSavingOpen}
					onClose={this.closeSavingDialog}
					onContinue={this.continueSavingDialog}
					processingText={'Processing your report.'}
					successText={'Report transmitted successfully. Thank you.'}
					status={savingStatus}
				/>

				<Snackbar
					anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
					open={true}
					onClose={this.handleClose}
					ContentProps={{
						'aria-describedby': 'message-id',
					}}
					message={
						<span id="message-id" style={{ fontSize: 20 }}>
							{durationFormatted}
						</span>
					}
				/>
			</Paper>
		);
	}

	setBase64StringFunction = (func) => {
		this.getBase64StringFromAccidentDrawing = func;
	};

	renderAccidentDrawing = () => {
		return <AccidentDrawing setBase64StringFunction={this.setBase64StringFunction} />;
	};

	renderReportFields = () => {
		const { reportType } = this.state;
		const formFields = infoByReportType[reportType].formFields;
		return this.renderFormFields(formFields);
	};

	renderFormFields = (formFields) => {
		return formFields.map((formField) => {
			const fields = _.isArray(formField) ? formField : [formField];
			const md = _.parseInt(12 / fields.length, 10);

			//let sm, md  = 10;
			//let lg = 8;
			let container = { sm: 10, md: 10, lg: 8 };
			if (fields[0].path === 'accidentDrawing') {
				container = { sm: 12, md: 12, lg: 12 };
			}

			const key = `cont_${fields[0].path || fields[0].section || fields[0].note}`;
			return (
				<Grid spacing={2} container key={key}>
					<Grid item xs={12} sm={container.sm} md={container.md} lg={container.lg}>
						<Grid spacing={2} container>
							{fields.map((field) => {
								return (
									<Grid item xs={12} md={md} key={field.path || field.section || field.note}>
										{this.renderField(field)}
									</Grid>
								);
							})}
						</Grid>
					</Grid>
				</Grid>
			);
		});
	};

	renderField = (field) => {
		if (field.type === 'string') {
			return <FormText label={field.label} {...this.getInputProps(field.path)} />;
		} else if (field.type === 'multilineString') {
			return (
				<FormTextArea label={field.label} rows={field.lines} {...this.getInputProps(field.path)} />
			);
		} else if (field.type === 'date') {
			if (field.defaultNow) {
				const defaultNow = moment().format('YYYY-MM-DD');
				return (
					<FormDatePicker label={field.label} {...this.getInputProps(field.path, defaultNow)} />
				);
			} else {
				return <FormDatePicker label={field.label} {...this.getInputProps(field.path)} />;
			}
		} else if (field.type === 'time') {
			if (field.defaultNow) {
				const defaultNow = moment().format('YYYY-MM-DDTHH:mm:ss[Z]');
				return (
					<FormTimePicker label={field.label} {...this.getInputProps(field.path, defaultNow)} />
				);
			} else {
				return <FormTimePicker label={field.label} {...this.getInputProps(field.path)} />;
			}
		} else if (field.type === 'dateYearPicker') {
			return (
				<FormDatePicker
					isYearPicker={true}
					label={field.label}
					{...this.getInputProps(field.path)}
				/>
			);
		} else if (field.type === 'enum') {
			return (
				<FormSelect
					label={field.label}
					options={field.options}
					{...this.getInputProps(field.path)}
				/>
			);
		} else if (field.type === 'boolean') {
			return <FormSwitch label={field.label} {...this.getInputProps(field.path, false)} />;
		} else if (field.type === 'accidentDrawing') {
			return this.renderAccidentDrawing();
		} else if (field.section) {
			return <SectionHeader key={field.section} label={field.section} />;
		} else if (field.note) {
			return <Note key={field.section} label={field.note} />;
		} else {
			return <div>MISSING TYPE {field.type}</div>;
		}
	};
}

SaveReport.propTypes = {
	addDriverReport: PropTypes.func.isRequired,
	updateDriverReport: PropTypes.func.isRequired,
	addResource: PropTypes.func.isRequired,

	getTicket: PropTypes.func.isRequired,
	ticket: PropTypes.object,
	searchMyTickets: PropTypes.func.isRequired,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	isAdmin: PropTypes.bool,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	DriverReportContainer,
	ResourceContainer,
	TicketContainer,
	requireClockIn,
])(SaveReport);
